import { type ReactNode } from "react";

interface PanelProps {
	children: ReactNode;
	title?: string;
}

export function Panel({ children, title }: PanelProps) {
	return (
		<div className="algoliaAutocompletePanel" title={title}>
			<div className="algoliaAutocompletePanel__body">
				{children}
			</div>
		</div>
	);
}
